import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

var _ref = /*#__PURE__*/React.createElement("polygon", {
  points: "27.22 31.92 14.64 31.92 8.36 25.69 8.36 14.63 27.22 14.63 27.22 31.92"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: "1.95",
  y: "7.4",
  width: "8.05",
  height: "4.65"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: "8.24",
  y: "17.34",
  width: "19.8",
  height: "12.73",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.77,2.82c0-1.06-.55-2.45-1.3-2.45H8.59c-.75,0-1.06,1.39-1.06,2.45V6H27.77Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.79,5.72H3C1.42,5.72.37,7.53.37,8.8V19c0,1.83,1.34,3.71,3.16,3.71H8.06l0,2.89,6.24,6.31h13v-9.2h4.94A3.82,3.82,0,0,0,35.73,19V8.8A3.38,3.38,0,0,0,32.79,5.72ZM4.24,11.17a1.41,1.41,0,1,1,1.4-1.41A1.41,1.41,0,0,1,4.24,11.17Zm4.1-.37a1,1,0,1,1,0-2,1,1,0,1,1,0,2Zm19,21.12H14.52v-6.4H8.15v-9.9h19.1Z"
});

export default createSvgIcon(stroke => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36.1 32.29"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, _ref, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
  d: "M28.2,6.4H7V2.82C7,1.46,7.39,0,8.33,0H26.59c1,0,1.61,1.64,1.61,2.82ZM7.53,5.66h20.1V2.82c0-.92-.49-2.08-1-2.08H8.33c-.55,0-.8,1.21-.8,2.08Z",
  fill: stroke
}), _ref5, /*#__PURE__*/React.createElement("path", {
  d: "M27.71,32.29H14.14v-.06L7.87,25.89H7.78V25.8l-.07-.07,0-2.67H3.53C1.45,23.06,0,20.91,0,19V8.8C0,7.39,1.17,5.35,3,5.35h29.8A3.72,3.72,0,0,1,36.1,8.8V19a4.18,4.18,0,0,1-3.85,4.08H27.67Zm-12.83-.77H26.94v-5.2L26.88,16H8.52v9.17h6.36Zm-6-5.63,5.23,5.29V25.89Zm18.74-3.56h4.6A3.47,3.47,0,0,0,35.37,19V8.8a3,3,0,0,0-2.58-2.71H3C1.64,6.09.74,7.72.74,8.8V19c0,1.58,1.14,3.35,2.79,3.35H7.78V15.25H27.61ZM4.24,11.53A1.78,1.78,0,1,1,6,9.76,1.78,1.78,0,0,1,4.24,11.53Zm4.1-.36A1.36,1.36,0,1,1,9.7,9.81,1.36,1.36,0,0,1,8.34,11.17Z",
  fill: stroke
}))))), 'Printer');